import React from "react"
import Layout from "../../components/layout"
import Seo from "../../components/seo"
import ServicesMain from "../../components/ServicesMain"

const services = () => {
  return (
    <Layout>
      <Seo Sitetitle="Services" />
      <section className="full-servies">
        <ServicesMain />
      </section>
    </Layout>
  )
}

export default services
